import React from "react"
import { AccesDirectItem } from "./render-acces-direct-styled"
import { accesDirectItem } from "../acces-direct.module.scss"
import PropTypes from "prop-types"
import AccesDirect from "../AccesDirectItem/acces-direct-item"

const RenderAccesDirect = ({ accesDirectData }) => {
  const accesDirects = accesDirectData.allDirectLinkEntityDirectLinkEntity.edges
  return (
    <>
      {accesDirects.map(({ node }) => (
        <AccesDirectItem key={node.drupal_id} className={accesDirectItem}>
          <AccesDirect accesDirect={node} />
        </AccesDirectItem>
      ))}
    </>
  )
}

RenderAccesDirect.propTypes = {
  accesDirectData: PropTypes.object.isRequired,
}

export default RenderAccesDirect
